import { axiosInstance } from "./";

const getServiceCenters = async (params) =>
    await axiosInstance.get("/service_centers", { params });

export {
    getServiceCenters
}